(function($) {

	"use strict";

/** --------------------------------------------------
 * 
 *   THEME SCRIPT
 *
 *   TABLE OF CONTENTS
 *   document ready
 *
 *  -------------------------------------------------- */

	const $body = $('body');


/** --------------------------------------------------
    #document ready
    -------------------------------------------------- */

	$(document).ready(function() {

		//Language fill
		const mobile_language_toggle = $('.mobile-language-toggle .lang-selected-abbr');
		const lang = $('html').attr('lang');
		mobile_language_toggle.text(lang);

		//user menu 
		$('.mobile-user-toggle button').on('click', function(){
			$body.toggleClass('show-mobile-user-menu');
			$body.removeClass('show-mobile-menu-language show-mobile-mega-menu');
		});

		//language menu 
		$('.mobile-language-toggle button').on('click', function(){
			$body.toggleClass('show-mobile-menu-language');
			$body.removeClass('show-mobile-user-menu show-mobile-mega-menu');
		});

		//mega menu
		$('.slideout-navigation-content .collection').on('click', function(e) {
			e.preventDefault();
			$body.addClass('show-mobile-mega-menu');
		});

		//close mega menu
		$('.mega-menu-back-button').on('click', function() {
			$body.removeClass('show-mobile-mega-menu');
			$(".site-header__menu").removeClass("show-products");
		});

		//open products on mobile
		$('.menu a.collection').on("click", function () {
			$(".site-header__menu").addClass("show-products");
		});

		//mobile cart / basket header
		$('[data-nav-toggle]').on("click", function () {
			$("body").toggleClass("js-sitenav-visible");
			$("html").toggleClass("mobile-menu-open");
			$(".site-header").toggleClass("mobile-menu-open");
    });
	});
})(jQuery);
